import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.animation-decoration-style-3').forEach((element) => {
  gsap.fromTo(
    element,
    { rotate: 0 },
    {
      rotate: 360,
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',
        end: 'bottom top-=150',
        scrub: true,
      },
    }
  );
});

let mm = gsap.matchMedia();

mm.add('(min-width: 1025px)', () => {
  gsap.utils
    .toArray('.animation-decoration-style-1.animation-decoration-1')
    .forEach((element) => {
      gsap.fromTo(
        element,
        { rotate: 0 },
        {
          rotate: -15,
          scrollTrigger: {
            trigger: element,
            start: 'center bottom',
            end: 'center center',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-1.animation-decoration-2')
    .forEach((element) => {
      gsap.fromTo(
        element,
        { x: -75, y: 175, opacity: 0 },
        {
          x: 0,
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'center center',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-2.animation-decoration-1')
    .forEach((element) => {
      gsap.fromTo(
        element,
        {
          scale: 0.5,
          rotate: 90,
          transformOrigin: '70% 35%',
        },
        {
          scale: 1,
          rotate: 0,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'center center-=20%',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-5.animation-decoration-1')
    .forEach((element) => {
      gsap.fromTo(
        element,
        {
          y: 150,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'center center',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-5.animation-decoration-2')
    .forEach((element) => {
      gsap.fromTo(
        element,
        {
          y: -250,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom-=20%',
            end: 'center center-=30%',
            scrub: true,
          },
        }
      );
    });

  // gsap.utils.toArray('.image-text__icon-wrap').forEach((icon, index) => {
  //   gsap.fromTo(
  //     icon,
  //     {
  //       x: 100 - 25 * index,
  //     },
  //     {
  //       x: -100 - 40 * index, // Move to the left
  //       scrollTrigger: {
  //         trigger: icon,
  //         start: `top bottom-=${100 + 65 * index}`,
  //         end: `top top-=${200 + 65 * index}`,
  //         scrub: true,
  //       },
  //       ease: 'power2.out',
  //     }
  //   );
  // });

  // gsap.utils.toArray('.image-text__single-icon').forEach((icon) => {
  //   gsap.fromTo(
  //     icon,
  //     {
  //       x: 300,
  //       y: 150,
  //       opacity: 0,
  //       transition: 'none',
  //     },
  //     {
  //       x: -300,
  //       y: -100,
  //       opacity: 1,
  //       scrollTrigger: {
  //         trigger: icon,
  //         start: `top bottom`,
  //         end: `top top`,
  //         scrub: true,
  //       },
  //       ease: 'power2.out',
  //     }
  //   );
  // });

  // Animation for images with the animate-vertical-lg class on desktop
  gsap.utils.toArray('.animate-vertical-lg').forEach((image) => {
    gsap.fromTo(
      image,
      { y: -100 }, // Starting position (slightly above the normal position)
      {
        y: 100, // Ending position (slightly below)
        scrollTrigger: {
          trigger: image,
          start: 'top bottom', // When the top of the image hits the bottom of the viewport
          end: 'bottom top', // When the bottom of the image hits the top of the viewport
          scrub: true, // Smooth scrubbing animation
        },
      }
    );
  });

  // Animation for text with the animate-vertical-sm class on desktop
  gsap.utils.toArray('.animate-vertical-sm').forEach((text) => {
    gsap.fromTo(
      text,
      { y: 25 }, // Smaller starting offset for text
      {
        y: 0, // End when text reaches its normal position (center)
        scrollTrigger: {
          trigger: text,
          start: 'top bottom', // Start animating when the top of the element hits the bottom of the viewport
          end: 'center center', // Stop animating when the element is centered in the viewport
          scrub: true, // Smooth scrubbing effect
        },
      }
    );
  });

  // Animation for the hero image on desktop
  gsap.utils.toArray('.fly-from-left').forEach((element) => {
    gsap.from(element, {
      x: -300, // Smaller offset from the left on mobile
      opacity: 0,
      duration: 1, // Slightly shorter duration on mobile
      ease: 'power3.out',
      onStart: function () {
        document.querySelector('.fly-from-left').style.visibility = 'visible';
      },
    });
  });

  // gsap.fromTo(
  //   '.animation-vertical-hero',
  //   { y: 0, opacity: 1 }, // Use GSAP y for animation
  //   {
  //     y: 750,
  //     opacity: 0,
  //     scrollTrigger: {
  //       trigger: '.animation-vertical-hero',
  //       start: 'top-=150 top',
  //       end: 'bottom top',
  //       scrub: true,
  //     },
  //   }
  // );

  gsap.utils.toArray('.fly-from-bottom').forEach((element) => {
    gsap.from(element, {
      y: 400,
      opacity: 0,
      duration: 2,
      ease: 'power3.out',
      onStart: function () {
        document.querySelector('.fly-from-bottom').style.visibility = 'visible';
      },
    });
  });
});

mm.add('(max-width: 1024px)', () => {
  gsap.utils.toArray('.fly-from-bottom').forEach((element) => {
    gsap.from(element, {
      y: 300,
      opacity: 0,
      duration: 1.5,
      ease: 'power3.out',
      onStart: function () {
        document.querySelector('.fly-from-bottom').style.visibility = 'visible';
      },
    });
  });

  gsap.utils
    .toArray('.animation-decoration-style-1.animation-decoration-1')
    .forEach((element) => {
      gsap.fromTo(
        element,
        { rotate: 0 },
        {
          rotate: -15,
          scrollTrigger: {
            trigger: element,
            start: 'center bottom',
            end: 'center center',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-1.animation-decoration-2')
    .forEach((element) => {
      gsap.fromTo(
        element,
        { x: -30, y: 100, opacity: 0 },
        {
          x: 0,
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'center center',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-2.animation-decoration-1')
    .forEach((element) => {
      gsap.fromTo(
        element,
        {
          scale: 0.5,
          rotate: 90,
          transformOrigin: '70% 35%',
        },
        {
          scale: 1,
          rotate: 0,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'center center-=20%',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-5.animation-decoration-1')
    .forEach((element) => {
      gsap.fromTo(
        element,
        {
          y: 150,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'center center',
            scrub: true,
          },
        }
      );
    });

  gsap.utils
    .toArray('.animation-decoration-style-5.animation-decoration-2')
    .forEach((element) => {
      gsap.fromTo(
        element,
        {
          y: -250,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom-=20%',
            end: 'center center-=30%',
            scrub: true,
          },
        }
      );
    });

  // gsap.utils.toArray('.image-text__single-icon').forEach((icon) => {
  //   gsap.fromTo(
  //     icon,
  //     {
  //       x: '50vw',
  //       y: 100,
  //       opacity: 0,
  //       transition: 'none',
  //     },
  //     {
  //       x: 0,
  //       y: 0,
  //       opacity: 1,
  //       scrollTrigger: {
  //         trigger: icon,
  //         start: `top bottom`,
  //         end: `top top`,
  //         scrub: true,
  //       },
  //       ease: 'power2.out',
  //     }
  //   );
  // });

  // gsap.fromTo(
  //   '.animation-vertical-hero',
  //   { y: 0, opacity: 1 }, // Use GSAP y for animation
  //   {
  //     y: 750,
  //     opacity: 0,
  //     scrollTrigger: {
  //       trigger: '.animation-vertical-hero',
  //       start: 'top-=150 top',
  //       end: 'bottom top',
  //       scrub: true,
  //     },
  //   }
  // );

  // Adjusted animation for images with the animate-vertical-lg class on mobile
  gsap.utils.toArray('.animate-vertical-lg').forEach((image) => {
    gsap.fromTo(
      image,
      { y: -50 }, // Smaller starting offset on mobile
      {
        y: 50, // Smaller ending offset on mobile
        scrollTrigger: {
          trigger: image,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  });

  // Adjusted animation for text with the animate-vertical-sm class on mobile
  gsap.utils.toArray('.animate-vertical-sm').forEach((text) => {
    gsap.fromTo(
      text,
      { y: 25 }, // Even smaller starting offset for text on mobile
      {
        y: 0, // End at the normal position (centered)
        scrollTrigger: {
          trigger: text,
          start: 'top bottom',
          end: 'center center', // Stop when the element is centered
          scrub: true,
        },
      }
    );
  });

  // Adjusted animation for the hero image on mobile
  gsap.utils.toArray('.fly-from-left').forEach((element) => {
    gsap.from(element, {
      x: -200, // Smaller offset from the left on mobile
      opacity: 0,
      duration: 1, // Slightly shorter duration on mobile
      ease: 'power3.out',
      onStart: function () {
        document.querySelector('.fly-from-left').style.visibility = 'visible';
      },
    });
  });
});
